/**
 * tasksense-capability-service API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CapabilityFieldRecord { 
    capabilityCode: string;
    capabilityVersion: string;
    fieldRole: CapabilityFieldRecord.FieldRoleEnum;
    fieldName: string;
    groupName?: string;
    fieldKind: CapabilityFieldRecord.FieldKindEnum;
    cardinality: CapabilityFieldRecord.CardinalityEnum;
    required?: boolean;
    defaultValueJson?: string;
    description?: string;
    fieldOrder?: number;
    connectorType?: string;
    dataType?: string;
    enumValuesJson?: string;
    userdataType?: string;
    userdataAttrFilterJson?: string;
    /**
     * TASK-217 / TASK-218. Hand-added ahead of the generator regen — the
     * backend already emits these; remove the hand-edit once the OpenAPI
     * client is regenerated post-deploy.
     */
    isResource?: boolean;
    isSecret?: boolean;
}
export namespace CapabilityFieldRecord {
    export const FieldRoleEnum = {
        Input: 'INPUT',
        Output: 'OUTPUT'
    } as const;
    export type FieldRoleEnum = typeof FieldRoleEnum[keyof typeof FieldRoleEnum];
    export const FieldKindEnum = {
        Connector: 'Connector',
        Data: 'Data'
    } as const;
    export type FieldKindEnum = typeof FieldKindEnum[keyof typeof FieldKindEnum];
    export const CardinalityEnum = {
        Single: 'single',
        List: 'list'
    } as const;
    export type CardinalityEnum = typeof CardinalityEnum[keyof typeof CardinalityEnum];
}


